import './loading.css';
import { useCustomTheme } from '../../hooks/useCustomTheme';

const BackdropLoading = () => {
  const { theme } = useCustomTheme();

  return (
    <div
      className="loading"
      style={{ backgroundColor: theme.colors.background }}
    >
      <div className="panela-loader">
        <div className="loader"></div>
        <div className="panela-container">
          <div className="panela"></div>
          <div className="cabo-panela"></div>
        </div>
        <div className="shadow"></div>
      </div>
    </div>
  );
};

export default BackdropLoading;
